/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * An IP type is an enum that can be v4 or v6
 */
export enum IPType {
	V4 = "v4",
	V6 = "v6",
}
